import { useEffect, useRef } from "react";

const FOCUSABLE =
  'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]),' +
  ' textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

// O que faz um overlay se comportar como diálogo, compartilhado pelo modal
// centralizado e pelo drawer lateral: a página não rola atrás, o foco entra ao
// abrir, o Tab não escapa e Esc ou scrim fecham.
export function useDialogChrome(onClose) {
  const dialogRef = useRef(null);

  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, []);

  // Devolver o foco a quem abriu é parte do ciclo: sem isso, fechar o diálogo
  // joga o Tab de volta para o topo da página.
  useEffect(() => {
    const opener = document.activeElement;
    const [firstFocusable] = dialogRef.current.querySelectorAll(FOCUSABLE);
    (firstFocusable || dialogRef.current).focus();

    return () => opener?.focus?.();
  }, []);

  // aria-modal esconde o resto da página do leitor de tela, mas não do Tab:
  // sem prender o foco, a tecla leva para controles que já não estão à vista.
  const trapTab = (event) => {
    const focusables = Array.from(dialogRef.current.querySelectorAll(FOCUSABLE));
    if (focusables.length === 0) return;

    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    const leaving = event.shiftKey ? first : last;
    if (document.activeElement !== leaving) return;

    event.preventDefault();
    (event.shiftKey ? last : first).focus();
  };

  const handleKeyDown = (event) => {
    if (event.key === "Escape") onClose();
    if (event.key === "Tab") trapTab(event);
  };

  // Fecha no mousedown, não no click: quem começa a arrastar uma seleção
  // dentro do painel e solta fora não pediu para fechar.
  const handleOverlayPress = (event) => {
    if (event.target === event.currentTarget) onClose();
  };

  return { dialogRef, handleKeyDown, handleOverlayPress };
}
